import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function ProductCard({ product }) {
  const img = product.images?.[0];
  return (
    <Link
      to={`/products/${product.slug}`}
      className="group block card-light overflow-hidden rounded-sm"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="aspect-[4/3] bg-[#F5F5F5] overflow-hidden relative">
        {img ? (
          <img src={img} alt={product.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#C1121F] font-heading font-bold text-3xl">
            {product.name?.charAt(0)}
          </div>
        )}
        {product.featured && (
          <span className="absolute top-3 left-3 chip bg-[#C1121F] text-white">Featured</span>
        )}
      </div>
      <div className="p-6">
        <div className="overline mb-2">Fasteners</div>
        <h3 className="h-card text-[#1C1C1C] group-hover:text-[#C1121F] transition-colors">{product.name}</h3>
        <p className="mt-2 font-body text-sm text-[#4B5563] line-clamp-2">{product.short_description}</p>
        <div className="mt-5 inline-flex items-center gap-2 font-heading font-semibold text-sm text-[#C1121F]">
          View Specifications <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </Link>
  );
}

export function CategoryCard({ category }) {
  return (
    <Link
      to={`/products/category/${category.slug}`}
      className="group block relative overflow-hidden rounded-sm border border-[#333] hover:border-[#C1121F] transition-all"
      data-testid={`category-card-${category.slug}`}
    >
      <div className="aspect-[5/4] bg-[#0A0A0A]">
        {category.image && (
          <img src={category.image} alt={category.name} loading="lazy" className="w-full h-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-500" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />
      </div>
      <div className="absolute inset-0 p-6 flex flex-col justify-end">
        <div className="overline mb-1">Category</div>
        <h3 className="h-card text-white">{category.name}</h3>
        <p className="mt-2 font-body text-sm text-white/70 line-clamp-2">{category.description}</p>
        <div className="mt-4 inline-flex items-center gap-2 font-heading font-semibold text-sm text-[#C1121F] opacity-80 group-hover:opacity-100">
          Explore <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </Link>
  );
}
